import { Component, OnInit , AfterViewInit, ComponentFactoryResolver } from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import {DataService} from '../data.service';
import {environment} from '../../environments/environment.prod'
import {Meta,Title,SafeUrl,DomSanitizer} from '@angular/platform-browser';
import{HomeComponent} from '../home/home.component';

declare var $:any;

@Component({
  selector: 'app-landing-modules',
  templateUrl: './landing-modules.component.html',
  styleUrls: ['./landing-modules.component.css']
})
export class LandingModulesComponent implements OnInit, AfterViewInit {

  moduleTitle:string="Landingpage";
  moduleData:any[]=[];
  complete:any[]=[];
  userId:number=-1;
  imgPath:string="";
  moduleId:number=-1;
  type:string="";
  isLink:boolean=true;
  isShareMenu:boolean=false;
  shareUrl:string="";
  arr=Array;
  myurl:string="whatsapp://send?text=http://happcoach.com/PilotServices/Module/"+this.moduleId+".html";
  isLoading:boolean=true;
  noModules:boolean=false;
  userTypeId:number=-1;
  planId:number=-1;
  isNext:boolean=false;
  freeTag:boolean=false;

  noStaticSlider: boolean = false;
  noStatic0Slider: boolean = false;
  seeMoreStaticSm: boolean = false;
  seeMoreStaticLg: boolean = false;
  seeMoreStaticSm0: boolean = false;
  seeMoreStaticLg0: boolean = false;
  staticBoxdata: any[]=[];
  staticBoxdata0: any[]=[];
  showStaticBox: boolean = false;
  showStaticBox0: boolean = false;

  constructor(
    private route:ActivatedRoute,
    private router:Router,
    private service:DataService,
    private title:Title,
    private meta:Meta,
    private sanitizer:DomSanitizer,
    private home:HomeComponent) {}

    ngOnInit() {

      this.title.setTitle("StratGist | "+this.moduleTitle+" Modules");
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
      this.getDashBoardModule();
      this.imgPath=environment.imagePath;
      this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
      this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
    }

    ngAfterViewInit(){
      $(window).scrollTop(0);   
      $('.cd-header').css('backgroundColor','rgb(147, 18, 70)');
      $(window).resize(() => {
        this.resizeHandler();
      });
    }

    resizeHandler(){
      this.activeStaticSlider();
      this.activeStatic0Slider();
      this.activeSlider();
    }

    ngDoCheck() {
      this.userId=localStorage.getItem("UserId")==null ? -1 : parseInt(localStorage.getItem("UserId"));
    }

    getDashBoardModule() {
    
      const inputJson={
        // "Type":type,
        "Type": "Adv",
        "UserId":this.userId
      }
    // console.log(inputJson);
      this.service.GetDashBoardAdvModule(inputJson).finally(() => {
        setTimeout(() => {
          this.activeStaticSlider();
          this.activeStatic0Slider();
          this.activeSlider();
        }, 150)
      })
      .subscribe(
        (result:any[])=>{
          this.isLoading=true;
          if(result['Status']=="Success"){
              this.complete=result['Completed'];
              this.moduleData = result['DashBoardData'];
              if(this.moduleData.length == 0) {
                this.noModules=true;
              } else {                
                for(var i=0 ; i < this.moduleData.length; i++) {
                  if(this.moduleData[i].IsFree == true||this.moduleData[i].IsFree == false) {
                    this.showStaticBox = true;
                    
                    this.staticBoxdata.push(this.moduleData[i])
                   // console.log(JSON.stringify(this.staticBoxdata))
                  } else {
                  //  this.showStaticBox0 = true;
                   // this.staticBoxdata0.push(this.moduleData[i])
                  }                  
                }
              }
           
              setTimeout(()=>{
                this.isLoading=false;
              },100)

          } else {
            this.service.alert(result['Message'],"error")
              this.isLoading=false;
          }
        },
        (error)=>{
        // console.log(error);
            this.isLoading=false;
        },

      )
    }

    activeSlider() {

      setTimeout(() => {
        // check for padding
        let widthScreen = $(window).width();
  
        if (widthScreen <= 1500 && widthScreen > 1024) {
        
          if(this.staticBoxdata.length < 5) {
            this.noStaticSlider = true;
          }

          if(this.staticBoxdata0.length < 5) {
            this.noStatic0Slider = true;
          }
         
        }
  
        if (widthScreen <= 1650 && widthScreen >= 1501) {
         
          if(this.staticBoxdata.length < 6) {
            this.noStaticSlider = true;
          }

          if(this.staticBoxdata0.length < 6) {
            this.noStatic0Slider = true;
          }
         
        }
  
        if (widthScreen <= 2200 && widthScreen >= 1651) {
        
          if(this.staticBoxdata.length < 7) {
            this.noStaticSlider = true;
          }

          if(this.staticBoxdata0.length < 7) {
            this.noStatic0Slider = true;
          }
         
        }
  
        if (widthScreen <= 2600 && widthScreen >= 2201) {
         
          if(this.staticBoxdata.length < 7) {
            this.noStaticSlider = true;
          }

          if(this.staticBoxdata0.length < 7) {
            this.noStatic0Slider = true;
          }
         
        }
      }, 2000)
  
    }

    activeStaticSlider() {  
  
      var width = $(window).width();
      if (width <= 768) {
        if (this.staticBoxdata.length > 3) {
          this.seeMoreStaticSm = true;
        }    
      }

      if (width > 768) {
        if (this.staticBoxdata.length > 5) {
          this.seeMoreStaticLg = true;
        }  
      }
    
      var $carousel9 = $('.slider9');      
  
      var settings9 = {
        dots: false,
        arrows: true,
        slide: '.slick-slideshow__slide',
        slidesToShow: 4,
        centerMode: true,
        centerPadding: '20px',
        infinite: false,
        draggable: false,
        swipeToSlide: false,
        initialSlide: 0,
        touchMove: false,
        nextArrow: '<i class="fa fa-chevron-circle-right  arrow-right fa-3x" id="free-right-static"></i>',
        prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: true,
              initialSlide: 0,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 680,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2,
              initialSlide: 0,
            }
          },
          {
            breakpoint: 500,
            settings: {
              arrows: true,
              initialSlide: 0,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '25px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 1100,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1500,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 4
            }
          },
  
          {
            breakpoint: 1650,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 5
            }
  
          },
  
          {
            breakpoint: 2200,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 6
            }
          },
  
          {
            breakpoint: 2600,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="free-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="free-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 8
            }
          },
  
        ]
      };
  
      if ($(window).width() > 768) {
        if (!$carousel9.hasClass('slick-initialized')) {
          $carousel9.slick(settings9);
        }
      }

      if ($(window).width() <= 768) {
        if (this.staticBoxdata.length > 1) {
          if (!$carousel9.hasClass('slick-initialized')) {
            $carousel9.slick(settings9);
          }
        }
      }
  
      $('#free-left-static').css('display', 'none')
      $carousel9.on('afterChange', function (slide, index) {
  
        if (index.options.slidesToShow == 1) {
          var count = index.slideCount - index.options.slidesToShow;
  
          if (index.currentSlide === 1) {
            $('#free-left-static').css('display', 'block')
          }
          if (index.currentSlide === 0) {
            $('#free-left-static').css('display', 'none')
          }
          if (index.currentSlide === count) {
            $('#free-right-static').css('display', 'none')
          }
  
          else {
            $('#free-right-static').css('display', 'block')
            if (index.currentSlide > 1) {
  
            }
            if (index.currentSlide == 1) {
  
            }
          }
        } else {
  
          var count = index.slideCount - index.options.slidesToShow;
          // console.log(count);
          if (index.currentSlide === 1) {
            $('#free-left-static').css('display', 'block')
          }
          if (index.currentSlide === 0) {
            $('#free-left-static').css('display', 'none')
          }
          if (index.currentSlide === count) {
            $('#free-right-static').css('display', 'none')
          }
  
          else {
            $('#free-right-static').css('display', 'block')
            if (index.currentSlide > 1) {
              //$(".slider").css('padding-left',"25px");
            }
            if (index.currentSlide == 1) {
              //$(".slider").css('padding-left',"15px");
            }
          }
        }
      });

    }

    activeStatic0Slider() {  
  
      var width = $(window).width();
      if (width <= 768) {           
        if(this.staticBoxdata0.length > 3) {
          this.seeMoreStaticSm0 = true;
        }
      }

      if (width > 768) {
        if (this.staticBoxdata0.length > 5) {
          this.seeMoreStaticLg0 = true;
        }       
      }
      
      var $carousel90 = $('.slider90');
  
      var settings90 = {
        dots: false,
        arrows: true,
        slide: '.slick-slideshow__slide',
        slidesToShow: 4,
        centerMode: true,
        centerPadding: '20px',
        infinite: false,
        draggable: false,
        swipeToSlide: false,
        initialSlide: 0,
        touchMove: false,
        nextArrow: '<i class="fa fa-chevron-circle-right  arrow-right fa-3x" id="paid-right-static"></i>',
        prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
        responsive: [
          {
            breakpoint: 900,
            settings: {
              arrows: true,
              initialSlide: 0,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2
            }
          },
          {
            breakpoint: 680,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 2,
              initialSlide: 0,
            }
          },
          {
            breakpoint: 500,
            settings: {
              arrows: true,
              initialSlide: 0,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '25px',
              slidesToShow: 1
            }
          },
          {
            breakpoint: 1100,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 3
            }
          },
          {
            breakpoint: 1500,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 4
            }
          },
  
          {
            breakpoint: 1650,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 5
            }
  
          },
  
          {
            breakpoint: 2200,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 6
            }
          },
  
          {
            breakpoint: 2600,
            settings: {
              arrows: true,
              nextArrow: '<i class="fa fa-chevron-circle-right arrow-right fa-3x" id="paid-right-static"></i>',
              prevArrow: '<i class="fa fa-chevron-circle-left arrow-left fa-3x" id="paid-left-static"></i>',
              centerMode: true,
              centerPadding: '30px',
              slidesToShow: 8
            }
          },
  
        ]
      };
  
      if ($(window).width() > 768) {
        if (!$carousel90.hasClass('slick-initialized')) {
          $carousel90.slick(settings90);
        }
      }
      
      if ($(window).width() <= 768) {
        if (this.staticBoxdata0.length > 1) {
          if (!$carousel90.hasClass('slick-initialized')) {
            $carousel90.slick(settings90);
          }
        }
      }
  
      $('#paid-left-static').css('display', 'none')
      $carousel90.on('afterChange', function (slide, index) {
  
        if (index.options.slidesToShow == 1) {
          var count = index.slideCount - index.options.slidesToShow;
  
          if (index.currentSlide === 1) {
            $('#paid-left-static').css('display', 'block')
          }
          if (index.currentSlide === 0) {
            $('#paid-left-static').css('display', 'none')
          }
          if (index.currentSlide === count) {
            $('#paid-right-static').css('display', 'none')
          }
  
          else {
            $('#paid-right-static').css('display', 'block')
            if (index.currentSlide > 1) {
  
            }
            if (index.currentSlide == 1) {
  
            }
          }
        } else {
  
          var count = index.slideCount - index.options.slidesToShow;
          // console.log(count);
          if (index.currentSlide === 1) {
            $('#paid-left-static').css('display', 'block')
          }
          if (index.currentSlide === 0) {
            $('#paid-left-static').css('display', 'none')
          }
          if (index.currentSlide === count) {
            $('#paid-right-static').css('display', 'none')
          }
  
          else {
            $('#paid-right-static').css('display', 'block')
            if (index.currentSlide > 1) {
              //$(".slider").css('padding-left',"25px");
            }
            if (index.currentSlide == 1) {
              //$(".slider").css('padding-left',"15px");
            }
          }
        }
      });

    }
  
    setSlideVisibility(carousel) {
      //Find the visible slides i.e. where aria-hidden="false"
      var visibleSlides = carousel.find('.slick-slideshow__slide[aria-hidden="false"]');
      //Make sure all of the visible slides have an opacity of 1
      $(visibleSlides).each(function () {
        $(this).css('opacity', 1);
      });
  
      //Set the opacity of the first and last partial slides.
      //$(visibleSlides).first().prev().css('opacity', 0);
    }

    showShareOptions(pvarId,pvarType){
    // console.log(pvarId);
      if(this.moduleId==pvarId){
          this.isShareMenu=!this.isShareMenu;
      }
      else {
          this.isShareMenu=true;
      }
      this.moduleId=pvarId;
      this.type=pvarType;

      this.updateMeta();
    }

    hideShareOptions(pvarId){
      if(this.moduleId==pvarId)
      this.isShareMenu=false;
    }

    addBookmark(pvarId,status) {
      if(this.userId==-1){
        this.service.alert("Please login to use this feature","error");
        return false;
      } else {
        const inputJson = {
            "ModuleId":pvarId,
            "Status":status,
            "UserId":this.userId
        }

        if(status=="False"){
          inputJson.Status=true
        }
        else if(status=="True"){
          inputJson.Status=false
        }
        // console.log(inputJson);
          this.service.AddBookmark(inputJson)
          .subscribe(
            (result:any[])=>{
              if(result['Status']=="Success"){
                if(inputJson.Status==true)
                this.service.alert("Bookmark added successfully","success");
                else
                this.service.alert("Bookmark removed successfully","success");

              } else {
                this.service.alert(result['Message'],"error");
              }

            },
            (error)=>{
            // console.log(error);
            },
            ()=>{

              this.moduleData=[];
              setTimeout(()=>{

                this.ngOnInit();
              },1000)


            }
          )
      }

    }

    // Harkamal Singh : Method to update meta tag
    updateMeta(){
      this.meta.updateTag({
      content: 'http://happcoach.com/PilotServices/Module/'+this.moduleId+'.html'
      },
      "property='og:url'"
      );
      this.shareUrl="https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
      // this.shareUrl="http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html"
    }

    // Harkamal Singh : Method to share to facebook,twitter,linkedin,g+
    shareToSocial(pvarChoice:number){
      if(pvarChoice==0){ // facebook
          window.open(
            "http://www.facebook.com/sharer/sharer.php?u="+this.shareUrl,
            '_blank' // <- This is what makes it open in a new window.
          );
      }

      if(pvarChoice==1){//twitter
        window.open(
        "https://twitter.com/intent/tweet?url="+this.shareUrl+"&text="+this.title.getTitle(),
        '_blank'
      );
    }
      if(pvarChoice==2){//linkedin
        window.open(
        "https://www.linkedin.com/shareArticle?mini=true&url="+this.shareUrl+"&title="+this.title.getTitle(),
        '_blank'
      )
      }

      if(pvarChoice==3){//google plus
        window.open(
        "https://plus.google.com/share?url="+this.shareUrl,
        '_blank'
      )
      }

    }

    getNumber(rating){
      return Math.trunc(rating);
    }

    sanitize(){
      let url:string="whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
        // let url:string="whatsapp://send?text=http://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";
      this.myurl=url;
       let s:SafeUrl=this.sanitizer.bypassSecurityTrustUrl(this.myurl);
       return s;
    }

    shareWhatsApp(){
      window.location.href = "whatsapp://send?text=https://stratgist.com/Module/workSmarts-"+this.moduleId+".html";
      // window.location.href = "whatsapp://send?text=https://52.66.183.31/MasterProjectByte/Module/"+this.moduleId+".html";
    }

    showActiveModule(pvarId){
       this.home.showActiveModule(pvarId);
       this.service.storageSub.next('change');
    }

    freeActive(){
       this.freeTag=true;
       this.isLink=false;
    }

    freeInactive(){
       this.freeTag=false;
       this.isLink=true;
    }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/landing-modules/landing-modules.component.ts